import {AutocompleteAjaxSeeker} from "@ui-seeker/core";
import {BACKEND_APIS} from "../../@constants";
import React from "react";
import {bookingWeeks} from "../../@signals";

export default function AppBookingWeeksAutocomplete({ ...props }) {

    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        multiple
        value={bookingWeeks.value}
        onChange={e => {
            bookingWeeks.value = e.target.value
        }}
        label="Booking Weeks"
        placeholder="Booking Weeks"
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/lastWeeks`}
        {...props}
    />
}